import script from "./SolicitarCuradoria.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitarCuradoria.vue?vue&type=script&setup=true&lang=js"

import "./SolicitarCuradoria.vue?vue&type=style&index=0&id=161852e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-161852e0"]])

export default __exports__